module.exports = __webpack_public_path__ + "img/car1.2d99eaed.png";